import React from 'react';

import svg from './assets/icons-16-minus.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconMinus = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-minus" />;
